import { render, staticRenderFns } from "./SetSysLang.vue?vue&type=template&id=a63eefec&scoped=true"
import script from "./SetSysLang.vue?vue&type=script&lang=js"
export * from "./SetSysLang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63eefec",
  null
  
)

export default component.exports